(function () {
  function setupAccordion(chipsContainer) {
    if (!chipsContainer || chipsContainer.getAttribute('data-coupon-accordion-ready') === 'true') return;

    var chips = Array.prototype.slice.call(chipsContainer.querySelectorAll('[data-coupon-code]'));
    if (chips.length <= 1) return;

    chipsContainer.setAttribute('data-coupon-accordion-ready', 'true');

    // Keep the applied (or first) coupon inline; move the rest into a floating popover
    // so expanding the list never pushes or covers the product list area.
    var primary = chipsContainer.querySelector('[data-coupon-code].is-applied') || chips[0];
    var others = chips.filter(function (chip) { return chip !== primary; });
    primary.hidden = false;

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'coupon-accordion-toggle';
    toggle.setAttribute('data-coupon-accordion-toggle', '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Show all coupons (' + chips.length + ')';

    var popover = document.createElement('div');
    popover.className = 'coupon-accordion-popover';
    popover.hidden = true;
    others.forEach(function (chip) {
      chip.hidden = false;
      popover.appendChild(chip);
    });

    // Insert immediately (while hidden) so later scripts can still find and bind
    // click handlers to these chips via document-wide queries; only reposition
    // into <body> on open, once those handlers already exist.
    if (chipsContainer.parentNode) {
      chipsContainer.parentNode.insertBefore(toggle, chipsContainer.nextSibling);
      toggle.parentNode.insertBefore(popover, toggle.nextSibling);
    }

    var closePopover = function () {
      popover.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Show all coupons (' + chips.length + ')';
      document.removeEventListener('mousedown', onOutsideInteraction, true);
      document.removeEventListener('keydown', onKeydown, true);
      window.removeEventListener('scroll', positionPopover, true);
      window.removeEventListener('resize', positionPopover);
    };

    function onOutsideInteraction(event) {
      if (popover.contains(event.target) || event.target === toggle) return;
      closePopover();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closePopover();
    }

    var positionPopover = function () {
      var rect = toggle.getBoundingClientRect();
      var width = Math.max(rect.width, 240);
      var left = Math.min(rect.left, window.innerWidth - width - 8);
      popover.style.top = (rect.bottom + 6) + 'px';
      popover.style.left = Math.max(left, 8) + 'px';
      popover.style.width = width + 'px';
    };

    var openPopover = function () {
      document.body.appendChild(popover);
      positionPopover();
      popover.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = 'Show less';
      document.addEventListener('mousedown', onOutsideInteraction, true);
      document.addEventListener('keydown', onKeydown, true);
      // Keep it anchored to the toggle instead of closing on incidental/momentum scroll.
      window.addEventListener('scroll', positionPopover, true);
      window.addEventListener('resize', positionPopover);
    };

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      if (popover.hidden) {
        openPopover();
      } else {
        closePopover();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-coupon-suggestions]').forEach(setupAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
